<template>
  <UFormGroup
    :label="$t('form.register.email')"
    :class="!isRegister ? 'no-ring-form' : ''"
    name="email"
    required
  >
    <template #default="{ error }">
      <UInput
        :value="modelValue"
        :class="`${
          !error && hasWarning ? 'border border-[#F59E0B] rounded-md' : ''
        } ${error? 'border border-red rounded-md' : ''}`"
        :placeholder="$t('form.register.email')"
        :trailing-icon="
          error || hasWarning
            ? 'i-heroicons-exclamation-triangle'
            : ''
        "
        :ui="{
          icon: {
            base: `${!error && hasWarning ? '!text-[#F59E0B]' : ''} ${
              error? '!text-red' : ''
            }`,
          },
        }"
        class="!mt-2"
        size="lg"
        type="email"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="validateEmail($event.target.value)"
      />
      <p v-if="!error && hasWarning" class="mt-2 text-sm">
        <span class="!text-[#F59E0B]">{{ t('form.register.email.warning') }}</span>
      </p>
    </template>

    <template #error="{ error }">
      <span
        v-if="error"
        v-text="
          t('form.invalid_field', { name: 'email' })
        "
      />
    </template>
  </UFormGroup>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null,
    required: false,
  },
  isRegister: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const { t } = useI18n();

const hasWarning = ref(false);

async function validateEmail(value: string) {
  try {
    if (!value) return hasWarning.value = true;

    const domain = value.split("@")[1];

    if (!domain) {
      return hasWarning.value = true;
    }

    const result: any = await $fetch(
      `https://dns.google/resolve?name=${domain}&type=MX`
    );

    if (result.Answer) {
      return hasWarning.value = false;
    }
  } catch (e: any) {
    return hasWarning.value = true;
  }

  return hasWarning.value = true;
}

</script>
